import { createRoot } from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Index } from "./pages/Index.tsx";
import { ErrorPage } from "./pages/ErrorPage.tsx";
import GlobalErrorBoundary from "./core/GlobalErrorBoundary.tsx";

const routes = [
  "/",
  "/unifi",
  "/protect",
  "/portal",
  "/access",
  "/connect",
  "/identity",
];

// we want all endpoints to behave the same way
const router = createBrowserRouter(
  routes.map((route) => ({
    path: route,
    element: <Index />,
    errorElement: <ErrorPage />,
  }))
);

createRoot(document.getElementById("root")!).render(
  <GlobalErrorBoundary>
    <RouterProvider router={router} />
  </GlobalErrorBoundary>
);
